export enum PRODUCT {
  NA = -1,
  UNLIMITED = 0,
  PRO = 1,
  BASIC = 2,
  FREE = 3,
}

export const PRODUCTS_TITLES = [
  { title: 'Unlimited', subtitle: 'The ultimate solution' },
  { title: 'Professional', subtitle: 'Powerful features' },
  { title: 'Basic', subtitle: 'Must-haves' },
  { title: 'Limited', subtitle: 'Limited access' },
];
